import { useContext, useEffect, useMemo, useState } from "react"

//styles
import noteStyle from "../../../styles/notifications/NotificationsForm.module.css"

//Formik
import { Formik, Form } from "formik"
import FormikTextInput from "../../../helpers/formikInputs/FormikTextInput"
import FormikDropDown from "../../../helpers/formikInputs/FormikDropDown"
import FormikCalendar from "../../../helpers/formikInputs/FormikCalendar"
import FormikCheckboxInput from "../../../helpers/formikInputs/FormikCheckboxInput"
import { UserContext } from "../../../context/userContext"
import FormikMultiSelectInput from "../../../helpers/formikInputs/FormikMultiSelectInput"

export default function NotificationsFilters(props) {
  const userCtx = useContext(UserContext)

  const [currentFilters, setCurrentFilters] = useState({
    createDateEnd: "",
    createDateStart: "",
    eventType: "All",
    includeRead: false,
    includeUnread: true,
    readDateEnd: "",
    readDateStart: "",
    search: "",
    sort: "newest",
    groupIds: [],
  })

  useEffect(() => {
    setCurrentFilters(props.filters)
  }, [props.filters])

  return (
    <div>
      <Formik
        initialValues={currentFilters}
        enableReinitialize
        onSubmit={(values) => {
          props.onSetFilters(values)
          props.onApplyFilters(values)
        }}
      >
        {({ handleSubmit, resetForm, setFieldValue }) => (
          <Form onSubmit={handleSubmit} autoComplete="off">
            <div
              className={`${noteStyle.noteFilterGridContainer} ${noteStyle.addSpace}`}
            >
              <div className={noteStyle.noteFilterGridItemTitleSearch}>
                Event title or description:
              </div>
              <div className={noteStyle.noteFilterGridItemEventType}>
                Filter by event type:
              </div>
              <div className={noteStyle.noteFilterGridItemSort}>
                Sort order:
              </div>
              <div
                className={`${noteStyle.noteFilterGridItemSearchBox} ${noteStyle.addSpace}`}
              >
                <FormikTextInput name={"search"} />
              </div>
              <div className={noteStyle.noteFilterGridItemEventTypeDD}>
                <FormikDropDown
                  name="eventType"
                  options={props.eventTypes}
                  optionLabel={"friendlyName"}
                  optionValue={"name"}
                />
              </div>
              <div className={noteStyle.noteFilterGridItemSortDD}>
                <FormikDropDown
                  name="sort"
                  options={[
                    { name: "Newest first (Default)", value: "newest" },
                    { name: "Oldest first", value: "oldest" },
                  ]}
                  optionLabel={"name"}
                  optionValue={"value"}
                />
              </div>
              <div className={`${noteStyle.noteFilterGridItemCreated}`}>
                Filter by date created:
              </div>
              <div className={`${noteStyle.noteFilterGridItemCreatedFrom}`}>
                <div>From:</div>
                <FormikCalendar name="createDateStart" />
              </div>
              <div className={`${noteStyle.noteFilterGridItemCreatedTo} `}>
                <div>To:</div>
                <FormikCalendar name="createDateEnd" />
              </div>
              <div className={noteStyle.noteFilterGridItemRead}>
                Filter by date read:
              </div>
              <div className={`${noteStyle.noteFilterGridItemReadFrom}`}>
                <div>From:</div>
                <FormikCalendar name="readDateStart" />
              </div>
              <div className={`${noteStyle.noteFilterGridItemReadTo}`}>
                <div>To:</div>
                <FormikCalendar name="readDateEnd" />
              </div>
              {!props.isSystemTab && (
                <>
                  <div
                    className={noteStyle.noteFilterGridItemTitleOrganization}
                  >
                    Filter by organization:
                  </div>
                  <div className={noteStyle.noteFilterGridItemOrganization}>
                    <FormikMultiSelectInput
                      name="groupIds"
                      options={props.organizationList}
                      optionLabel={"organization_name"}
                      optionValue={"organization_id"}
                      placeHolderValue={"All organizations"}
                    />
                  </div>
                </>
              )}

              <div className={noteStyle.noteFilterGridItemTitleInclude}>
                Include messages:{" "}
              </div>
              <div className={noteStyle.noteFilterGridItemIncludeUnread}>
                <div className={`${noteStyle.noteFilterCheckbox}`}>
                  <FormikCheckboxInput
                    name={"includeUnread"}
                    className={noteStyle.noteFilterCheckboxContainer}
                  />
                  <label
                    htmlFor={"includeUnread"}
                    style={{ marginLeft: "10px" }}
                  >
                    Unread messages
                  </label>
                </div>
              </div>
              <div className={noteStyle.noteFilterGridItemIncludeRead}>
                <div
                  className={`${noteStyle.addSpace} ${noteStyle.noteFilterCheckbox}`}
                >
                  <FormikCheckboxInput name={"includeRead"} />
                  <label style={{ marginLeft: "10px" }}>Read messages</label>
                </div>
              </div>
            </div>
            <div>
              <button className="btn" type="submit">
                Apply
              </button>
              <button
                className="btn"
                type="button"
                style={{ marginLeft: "10px" }}
                onClick={() => {
                  setCurrentFilters(props.defaultFilters)
                  props.onApplyFilters(props.defaultFilters)
                  props.onSetFilters(props.defaultFilters)
                  resetForm()
                }}
              >
                Reset
              </button>
            </div>
          </Form>
        )}
      </Formik>
    </div>
  )
}
